// extracted by css-extract-rspack-plugin
export default {"skeletons":"DuGgS","skeleton":"ZeL7a","mobile":"VPGj8","desktop":"b5cdv"};